import React, { useState, useEffect, useContext } from 'react';
import axios from '../../config/axios';

import AuthContext from '../../contexts/AuthContext';

import ExhibitionItem from './ExhibitionItem/ExhibitionItem';
import Spinner from '../../components/UI/Spinner/Spinner';

import classes from './Exhibition.module.scss';

const Exhibition = () => {
    const auth = useContext(AuthContext)[0];

    const [range, setRange] = useState(null);
    const [currentValue, setCurrentValue] = useState(1);
    const [state, setState] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        axios.get(`/exhibition.json?auth=${auth.token}`)
            .then(res => {
                const loadedData = Object.keys(res.data)
                    .map(key => ({
                        id: key,
                        data: res.data[key]
                    }))
                setState(loadedData);
                setRange(loadedData.length);
                setLoading(false);
            })
            .catch(err => {
                console.log('[EXHIBITION AXIOS ERR] ', err.message)
            })
    }, [])


    let displayedData = null;
    if (state && range) {
        displayedData = state.sort((el1, el2) => {
            if (el1.data.date > el2.data.date) {
                return 1;
            }
            return -1;
        })
        .map(el => <ExhibitionItem
            key={el.id}
            title={el.data.title}
            content={el.data.content}
        />)
    }

    let yearLinks = null;
    if (state && range) {
        yearLinks = state.map((el, index) => <div
            key={el.id}
            className={index === currentValue - 1 ? classes.YearIndicator : classes.YearInactive}
            onClick={() => setCurrentValue(index + 1)}>{el.data.date}</div>)
    }

    return <div className={classes.Right}>
        <h1>50 Years of Mathematics in Kielce</h1>
        {!loading
            ? <div className={classes.Exhibition}>
                <div className={classes.Content}>
                    {displayedData ? displayedData[currentValue - 1] : null}
                </div>
                <div className={classes.YearList}>
                    {yearLinks && yearLinks}
                </div>
            </div>
            : <Spinner />}
    </div>
}

export default Exhibition;